export enum ValidationState {
    PENDING = 'Pending',
    VALIDATED = 'Validated',
    NOTVALIDATED = 'NotValidated',
}

export interface IRbacUser {
    id: string;
    name: string;
    tenantId: string;
    emailAddress: string;
    phoneNumber: string;
    enabled: boolean;
    profilePictureUrl: string | null;
    displayName: string;
    jobTitle: string;
}

export const DefaultUser = (userId: string): IRbacUser => {
    return {
        id: userId,
        name: 'Default User',
        tenantId: 'Default Tenant',
    } as IRbacUser;
};

interface IClaim {
    type: string;
    value: string;
}

export interface IUserScope {
    name: string;
    claims: IClaim[];
}

interface IExternalId {
    provider: string;
    value: string;
}

export interface IUserWrite {
    name: string;
    emailAddress: string;
    phoneNumber?: string;
    enabled?: boolean;
    scopes?: IUserScope[];
    profilePictureUrl?: string;
    displayName: string | null;
    jobTitle: string | null;
    customId?: string;
}

export interface IUserRead extends IUserWrite {
    id: string;
    externalIds: IExternalId[];
    tenantId?: string;
    validationState: ValidationState;
}

export interface IUserDirectory {
    total: number;
    results: IUserRead[];
}

export type AgentType = 'agent' | 'supervisor';
